import React, { useEffect, useState, useRef } from "react";
import Option from "./Option";
// import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../components/modal/modal';
import ClipLoader from "react-spinners/ClipLoader";
import useStateRef from "react-usestateref";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import {
  addSimilarQuestions,
  changeTextUsingOpenAi,
  convertImgToText,
  deleteQuestionLanguageOption,
  editQuestionCorrectPromptAndLanguageVarient,
  editTestSeriesQuestion,
  getSimilarQuestions,
  updateConvertedQuestionValue,
  updateConvertedSolutionValue,
  updateOCRText,
} from "../../../api/testSeries/testseries";
// import Editor from 'ckeditor5-custom-build/build/ckeditor'

import Editor from "@ckeditor/ckeditor5-build-classic";
// import {Editor as ClassicEditor } from 'ckeditor5-custom-build/build/ckeditor'
import { CKEditor } from "@ckeditor/ckeditor5-react";
// import renderHTML from "react-render-html";
import renderHTML, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

import Modal from "react-bootstrap/Modal";
import { fileBaseUrl } from "../../..";
import { s3upload } from "../../../api/aws";
import CKEditorImageUpload from "../../../Utils/CKEditorImageUpload";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import { MenuItem, Select, Snackbar } from "@material-ui/core";
import { replaceImageSrc } from "../../../Utils/CKEditorImageUpload";
import html2canvas from "html2canvas";
import katex from "katex";
import "katex/dist/katex.min.css";

export const CK_EDITOR_SCRIPT = () => {
  const imageSelectors = ["span.image-inline img", "figure.image img"];
  const images = document.querySelectorAll(imageSelectors.join(","));

  images.forEach((img) => {
    const resolvedSrc = replaceImageSrc(ImagePathResolver(img.src));
    img.src = resolvedSrc;
    console.log(resolvedSrc, "Updated image src");
  });
};

export const wrapLatexWithCustomTag = (html) => {
  const inlineRegex = /\\\(.*?\\\)/g;
  const displayRegex = /\\\[(.*?)\\\]/g;

  const wrappedInline = html?.replace(inlineRegex, "<latex>$&</latex>");
  const wrappedDisplay = wrappedInline?.replace(
    displayRegex,
    "<latex>$&</latex>"
  );

  return wrappedDisplay;
};

export const ImagePathResolver = (path) => {
  if (path && (path.startsWith("https://") || path.startsWith("http://"))) {
    return path;
  } else {
    return "https://d2dn8tqui3vt36.cloudfront.net" + path;
  }
};
const HTML_PARSER_OPTIONS = {
  transform: (node) => {
    // do not render any <span> tags
    if (node.type === "tag" && node.name === "img") {
      node.attribs.src = replaceImageSrc(ImagePathResolver(node.attribs.src));

      node.attribs.width = "100%";
      //   return null;
    }
    if (node.type === "tag" && node.name === "latex") {
      const data = node?.children?.map((item) => {
        return <math-field read-only>{item?.data}</math-field>
      })
      return <div>{data}</div>;
    }
  },
};
function QuestionLanguageVarient({
  ocrConvertedQuestion,
  setOcrConvertedQuestion,
  queId,
  item,
  index,
  updateActiveLanguageQuestionData,
  setEditQuestionMarksModalVisible,
  editQuestionMarksModalVisible,
  queData,
}) {
  const [editQuestionModalVisible, setEditQuestionModalVisible] =
    useState(false);
  const [convertModalVisible, setConvertModalVisible] = useState(false);
  const [questionData, setQuestionData, questionDataRef] = useStateRef(item);
  const [editingQuestion, setEditingQuestion] = useState(false);
  const [questionOptions, setquestionOptions, questionOptionsRef] = useStateRef(
    item?.options || []
  );

  const [convertQuestionData, setConvertQuestionData] = useState({});

  const [openQuestionModal, setOpenQuestionModal] = useState(false);
  const [openSolutionModal, setOpenSolutionModal] = useState(false);

  const [convertedQuestion, setConvertedQuestion] = useState(
    questionData?.convertedValue || ""
  );
  const [convertingLoader, setConvertingLoader] = useState(false);
  const [updatingConvertedLoader, setUpdatingConvertedLoader] = useState(false);
  const [convertedSolution, setConvertedSolution] = useState();
  const [editLoader, setEditLoader] = useState(false);
  const [allSimilarQuestions, setAllSimilarQuestions] = useState([]);
  const [selectedSimilarQuestions, setSelectedSimilarQuestions] = useState([]);
  const [SnackBarMessage, setSnackBarMessage] = useState("");
  const [isSnackBarShow, setIsSnackBarShow] = useState(false);
  const [ocrTextLoading, setOcrTextLoading] = useState(false);
  
  // LaTeX to Image Converter states
  const [latexConverterModalVisible, setLatexConverterModalVisible] = useState(false);
  const [latexInput, setLatexInput] = useState("");
  const [latexPreviewKey, setLatexPreviewKey] = useState(0);
  const [convertingLatexToImage, setConvertingLatexToImage] = useState(false);
  const latexPreviewRef = useRef(null);
  
  // S3 Upload states
  const [uploadingToS3, setUploadingToS3] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadedImageUrls, setUploadedImageUrls] = useState(null); // {small, medium, large, xlarge}
  const [generatedImgTag, setGeneratedImgTag] = useState("");
  const [lastGeneratedCanvas, setLastGeneratedCanvas] = useState(null);
  
  const closeSnack = () => {
    setIsSnackBarShow(false);
  };

  useEffect(() => {
    setQuestionData(item);
    setConvertQuestionData(item);
    setquestionOptions(item?.options || []);
    setConvertedQuestion(questionData?.convertedValue || "");
    setConvertedSolution(questionData?.convertedSolution || "");
  }, [item, item?.options]);

  const handleInputChange = (e) => {
    const options = e.target?.options;
    const selectedValues = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedValues.push(allSimilarQuestions[i]);
      }
    }
    setSelectedSimilarQuestions(selectedValues);
  };

  // useEffect(() => {
  //     editQuestionMarksData['posMarks'] = queData.posMarks
  //     editQuestionMarksData['negMarksUnattempted'] = queData.negMarksUnattempted
  //     editQuestionMarksData['negMarks'] = queData.negMarks
  //     if (queData.negMarksUnattempted == 0 && queData.negMarks == 0)
  //         editQuestionMarksData['isNegativeMarking'] = false
  //     else
  //         editQuestionMarksData['isNegativeMarking'] = true
  // }, [])

  const handleOptionInput = (value, prompt, index, correct) => {
    const obj = { ...questionData };
    let arr = [...questionOptions];
    if (correct) {
      arr = arr.map((item) => ({ ...item, correct: false }));
      obj.correctPrompt = prompt;
    }
    arr[index] = { ...arr[index], value, prompt, correct };
    setquestionOptions(arr);
    setQuestionData(obj);
  };

  const handleEditQuestion = async (e) => {
    let ocrText = "";
    e.preventDefault();
    setEditLoader(true);
    const questionImgUrl = questionData?.value
      ?.split("><")[1]
      ?.split("src=")[1];

    if (questionImgUrl) {
      const request = await convertImgToText(questionImgUrl);

      ocrText = request?.response?.ParsedResults[0]?.ParsedText;
      setOcrConvertedQuestion(request?.response?.ParsedResults[0]?.ParsedText);
    }
    setEditingQuestion(true);
    const editData = { ...questionData, options: questionOptions };
    editData.id = item?.id;
    editData.testSeriesQuestion = { id: queData?.id };

    editQuestionCorrectPromptAndLanguageVarient(editData, (response) => {
      if (response.status) {
        updateActiveLanguageQuestionData({
          ...questionDataRef.current,
          options: questionOptionsRef.current,
        });
      }

      updateOCRinDB(response?.data?.id, ocrText);
    });
    setEditQuestionModalVisible(false);
    setEditingQuestion(false);
    setEditLoader(false);
  };

  const updateOCRinDB = async (id, text) => {
    const response = await updateOCRText(id, text);
    if (response.status) {
      const res = await getSimilarQuestions(text);

      const arr = res?.data?.data?.results?.map(
        (each) => each?.document?.structData
      );
      setAllSimilarQuestions(arr);
    }
  };

  const addquestionOptions = () => {
    setquestionOptions([...questionOptions, {}]);
  };
  const removeLastQuestionOption = () => {
    if (window.confirm("Are you sure you want to delete this option?")) {
      const questionoptions_arr = [...questionOptions];
      const slicedOption = questionoptions_arr.splice(
        questionoptions_arr?.length - 1,
        1
      );
      if (slicedOption[0].id) {
        deleteQuestionLanguageOption(slicedOption[0].id);
      }
      setquestionOptions(questionoptions_arr);
    }
  };

  const handleConvertQuestion = async (e) => {
    e.preventDefault();
    setUpdatingConvertedLoader(true);
    const response = await updateConvertedQuestionValue({
      convertedValue: convertedQuestion,
      id: questionData.id,
    });
    if (response.status) {
      setOpenQuestionModal(false);
      // setConvertedQuestion('')
      setQuestionData({ ...questionData, convertedValue: convertedQuestion });
    }
    setUpdatingConvertedLoader(false);
  };

  const checkConvertedQuestionHandler = async () => {
    setConvertingLoader(true);

    const response = await changeTextUsingOpenAi(
      questionData.value,
      "Rewrite this "
    );
    if (response.status) {
      setConvertedQuestion(response.data.content);
    }
    setConvertingLoader(false);
  };

  const handleConvertSolution = async (e) => {
    e.preventDefault();
    setUpdatingConvertedLoader(true);
    const response = await updateConvertedSolutionValue({
      convertedSolution,
      id: questionData.id,
    });
    if (response.status) {
      setOpenSolutionModal(false);
      // setConvertedSolution( '')
      setQuestionData({
        ...questionData,
        convertedSolution: convertedSolution,
      });
    }
    setUpdatingConvertedLoader(false);
  };

  const checkConvertedSolutionHandler = async () => {
    setConvertingLoader(true);
    const response = await changeTextUsingOpenAi(
      window.getSelection().toString(),
      "Rewrite this with proper bullets "
    );
    if (response.status) {
      const converted = convertedSolution + " " + response.data.content;
      setConvertedSolution(converted);
    }
    setConvertingLoader(false);
  };

  const addAllSimilarQuestions = async () => {


    const arr = selectedSimilarQuestions?.map((each) => each?.id);

    const response = await addSimilarQuestions(queData?.id, arr);
    if (response.status) {
      setSnackBarMessage(" Added Successfully");
      setIsSnackBarShow(true);
    } else {
      setSnackBarMessage("Something went wrong!");
      setIsSnackBarShow(true);
    }
  };

  const convertImgText = async () => {
    setOcrTextLoading(true);
    const questionImgUrl = questionData?.value
      ?.split("><")[1]
      ?.split("src=")[1];

    if (questionImgUrl) {
      const response = await convertImgToText(questionImgUrl);
      if (response.status) {

        setOcrConvertedQuestion(
          response?.response?.ParsedResults[0]?.ParsedText
        );

        const res = await getSimilarQuestions(
          response?.response?.ParsedResults[0]?.ParsedText
        );

        const arr = res?.data?.data?.results?.map(
          (each) => each?.document?.structData
        );
        setAllSimilarQuestions(arr);
      }
    }
    setOcrTextLoading(false);
  };

  // Download LaTeX as image directly
  const downloadLatexImage = async () => {
    if (!latexInput.trim()) {
      setSnackBarMessage("Please enter LaTeX code");
      setIsSnackBarShow(true);
      return;
    }

    setConvertingLatexToImage(true);

    try {
      // Wait for math-field to fully render
      await new Promise(resolve => setTimeout(resolve, 500));

      if (!latexPreviewRef.current) {
        throw new Error("Preview element not found");
      }

      // Get all math-field elements
      const mathFields = latexPreviewRef.current.querySelectorAll('math-field');
      
      if (mathFields.length === 0) {
        throw new Error("No math content found to render");
      }

      // Extract LaTeX values from each math-field
      const latexValues = [];
      mathFields.forEach((field) => {
        // Use MathLive API to get the LaTeX value
        const latexValue = field.value || field.textContent;
        if (latexValue) {
          latexValues.push(latexValue);
        }
      });

      if (latexValues.length === 0) {
        throw new Error("No LaTeX content found");
      }

      // Create a temporary container to render equations with KaTeX
      const tempContainer = document.createElement('div');
      tempContainer.style.position = 'fixed';
      tempContainer.style.left = '-9999px';
      tempContainer.style.top = '0';
      tempContainer.style.padding = '20px';
      tempContainer.style.backgroundColor = 'white';
      tempContainer.style.fontFamily = 'Arial, sans-serif';
      tempContainer.style.fontSize = '18px';
      document.body.appendChild(tempContainer);

      // Render each LaTeX equation using KaTeX
      latexValues.forEach((latex) => {
        const wrapper = document.createElement('div');
        wrapper.style.marginBottom = '20px';
        wrapper.style.display = 'block';
        
        try {
          // Use KaTeX to render the LaTeX
          katex.render(latex, wrapper, {
            displayMode: true,
            throwOnError: false,
            output: 'html', // Use HTML output for better compatibility
          });
        } catch (error) {
          console.error("Error rendering LaTeX:", error);
          // If KaTeX fails, show the raw LaTeX
          wrapper.textContent = latex;
        }
        
        tempContainer.appendChild(wrapper);
      });

      // Wait for KaTeX rendering to complete
      await new Promise(resolve => setTimeout(resolve, 300));

      // Capture the temporary container with html2canvas
      const canvas = await html2canvas(tempContainer, {
        backgroundColor: "white",
        scale: 3, // High quality
        useCORS: true,
        logging: false,
      });

      // Remove the temporary container
      document.body.removeChild(tempContainer);

      // Convert canvas to blob and download
      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `latex-equation-${Date.now()}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        setSnackBarMessage("Image downloaded successfully!");
        setIsSnackBarShow(true);
      }, "image/png");
      
    } catch (error) {
      console.error("Error downloading LaTeX image:", error);
      setSnackBarMessage("Failed to download image. Please try again.");
      setIsSnackBarShow(true);
      
      // Clean up temporary container if it exists
      const tempContainers = document.querySelectorAll('[style*="position: fixed"][style*="-9999px"]');
      tempContainers.forEach(container => {
        if (container.parentNode) {
          document.body.removeChild(container);
        }
      });
    } finally {
      setConvertingLatexToImage(false);
    }
  };

  // Helper function to generate scaled canvas
  const generateScaledCanvas = async (latexValues, targetWidth, scale) => {
    // Create a temporary container to render equations with KaTeX
    const tempContainer = document.createElement('div');
    tempContainer.style.position = 'fixed';
    tempContainer.style.left = '-9999px';
    tempContainer.style.top = '0';
    tempContainer.style.padding = '20px';
    tempContainer.style.backgroundColor = 'white';
    tempContainer.style.fontFamily = 'Arial, sans-serif';
    tempContainer.style.fontSize = '18px';
    tempContainer.style.width = `${targetWidth}px`;
    document.body.appendChild(tempContainer);

    // Render each LaTeX equation using KaTeX
    latexValues.forEach((latex) => {
      const wrapper = document.createElement('div');
      wrapper.style.marginBottom = '20px';
      wrapper.style.display = 'block';
      
      try {
        katex.render(latex, wrapper, {
          displayMode: true,
          throwOnError: false,
          output: 'html',
        });
      } catch (error) {
        console.error("Error rendering LaTeX:", error);
        wrapper.textContent = latex;
      }
      
      tempContainer.appendChild(wrapper);
    });

    // Wait for KaTeX rendering to complete
    await new Promise(resolve => setTimeout(resolve, 300));

    // Capture the temporary container with html2canvas
    const canvas = await html2canvas(tempContainer, {
      backgroundColor: "white",
      scale: scale,
      useCORS: true,
      logging: false,
    });

    // Remove the temporary container
    document.body.removeChild(tempContainer);

    return canvas;
  };

  // Upload LaTeX image to S3 with multiple responsive sizes
  const uploadLatexImageToS3 = async () => {
    if (!latexInput.trim()) {
      setSnackBarMessage("Please enter LaTeX code");
      setIsSnackBarShow(true);
      return;
    }

    setUploadingToS3(true);
    setUploadProgress(0);

    try {
      // Get all math-field elements and extract LaTeX values
      await new Promise(resolve => setTimeout(resolve, 500));

      if (!latexPreviewRef.current) {
        throw new Error("Preview element not found");
      }

      const mathFields = latexPreviewRef.current.querySelectorAll('math-field');
      
      if (mathFields.length === 0) {
        throw new Error("No math content found to render");
      }

      const latexValues = [];
      mathFields.forEach((field) => {
        const latexValue = field.value || field.textContent;
        if (latexValue) {
          latexValues.push(latexValue);
        }
      });

      if (latexValues.length === 0) {
        throw new Error("No LaTeX content found");
      }

      // Generate 4 different sized canvases for responsive images
      const sizes = [
        { name: 'small', width: 400, scale: 1 },
        { name: 'medium', width: 800, scale: 2 },
        { name: 'large', width: 1200, scale: 2.5 },
        { name: 'xlarge', width: 1600, scale: 3 }
      ];

      const uploadedUrls = {};
      const baseTimestamp = Date.now();

      // Generate and upload each size
      for (let i = 0; i < sizes.length; i++) {
        const sizeConfig = sizes[i];
        setUploadProgress(Math.round(((i + 0.5) / sizes.length) * 100));

        // Generate canvas for this size
        const canvas = await generateScaledCanvas(latexValues, sizeConfig.width, sizeConfig.scale);

        // Convert canvas to blob
        const blob = await new Promise((resolve) => {
          canvas.toBlob(resolve, 'image/png');
        });

        // Create File object with descriptive name
        const file = new File(
          [blob],
          `latex-${baseTimestamp}-${sizeConfig.name}.png`,
          { type: 'image/png' }
        );

        // Upload to S3
        const uploadResult = await s3upload(
          file,
          (progress) => {
            const overallProgress = ((i + (progress.loaded / progress.total)) / sizes.length) * 100;
            setUploadProgress(Math.round(overallProgress));
          },
          'latex-images/'
        );

        uploadedUrls[sizeConfig.name] = uploadResult.uri;
      }

      setUploadProgress(100);
      setUploadedImageUrls(uploadedUrls);

      // Generate IMG tag with responsive srcset
      const imgTag = `<img 
  src="${uploadedUrls.medium}" 
  srcset="${uploadedUrls.small} 400w,
          ${uploadedUrls.medium} 800w,
          ${uploadedUrls.large} 1200w,
          ${uploadedUrls.xlarge} 1600w"
  sizes="(max-width: 480px) 400px,
         (max-width: 768px) 800px,
         (max-width: 1024px) 1200px,
         1600px"
  alt="LaTeX equation"
  loading="lazy"
/>`;

      setGeneratedImgTag(imgTag);
      setSnackBarMessage("Images uploaded successfully!");
      setIsSnackBarShow(true);

    } catch (error) {
      console.error("Error uploading to S3:", error);
      setSnackBarMessage("Failed to upload images. Please try again.");
      setIsSnackBarShow(true);
    } finally {
      setUploadingToS3(false);
    }
  };

  // Copy IMG tag to clipboard
  const copyImgTagToClipboard = () => {
    if (!generatedImgTag) return;

    navigator.clipboard.writeText(generatedImgTag).then(() => {
      setSnackBarMessage("IMG tag copied to clipboard!");
      setIsSnackBarShow(true);
    }).catch(err => {
      console.error("Failed to copy:", err);
      setSnackBarMessage("Failed to copy. Please copy manually.");
      setIsSnackBarShow(true);
    });
  };

  const openLatexConverter = () => {
    setLatexConverterModalVisible(true);
    setLatexInput("");
  };

  // Trigger re-render of LaTeX preview when input changes
  useEffect(() => {
    setLatexPreviewKey(prev => prev + 1);
  }, [latexInput]);

  // useEffect(() => {
  //   if (questionData?.value?.length > 0) {
  //     convertImgText();
  //   }
  // }, [questionData]);

  // console.log("questionData", questionData);
  return (
    <div>
      <div className="row">
        <div className="col-6"></div>
        <div className="col-6">
          <button
            type="button"
            class="btn btn-success mr-1"
            data-toggle="modal"
            data-target="#addSectionModal"
            style={{
              position: "absolute",
              top: -38
            }}
            onClick={() => {
              setEditQuestionModalVisible(true);
              setTimeout(() => {
                console.log("hello")
                CK_EDITOR_SCRIPT();
              }, 1000);
            }}
          >
            Edit
          </button>
          {/* <button
            type="button"
            class="btn btn-success mr-1"
            onClick={() => {
              setOpenQuestionModal(true);
              setConvertedQuestion(questionData?.convertedValue);
            }}
          >
            Convert Question
          </button>
          <button
            type="button"
            class="btn btn-success mr-1"
            onClick={() => {
              setOpenSolutionModal(true);
              setConvertedSolution(questionData?.convertedSolution);
            }}
          >
            Convert Solution
          </button> */}
        </div>
      </div>
      <div
        className={`row rounded-sm ${queData.internSelectedPrompt === queData.correctPrompt
          ? "border border-success"
          : queData.internSelectedPrompt === null
            ? "border border-primary"
            : "border border-danger"
          }`}
      >
        <div className="col-6">
          {questionData?.questionPara?.length > 0 && (
            <div className="mb-2 mt-4">
              <h6>Comprehension </h6>
              {renderHTML(
                wrapLatexWithCustomTag(questionData?.questionPara) || "",
                HTML_PARSER_OPTIONS
              )}
            </div>
          )}

          <div className="mb-2 mt-5">
            {/* dangerouslySetInnerHTML={{ __html: questionData?.value }} */}
            <h6>Question </h6>
            {renderHTML(wrapLatexWithCustomTag(questionData?.value) || "", HTML_PARSER_OPTIONS)}
          </div>
          <div className="mb-2">
            {questionData?.options?.map((option, index) => {
              return (
                <Option
                  item={option}
                  index={index}
                  showConvertOption={true}
                  correctPrompt={questionData?.correctPrompt}
                />
              );
            })}

          </div>
          <div className="mb-2">
            {renderHTML(wrapLatexWithCustomTag(questionData?.solution) || "", HTML_PARSER_OPTIONS)}
          </div>
        </div>

        <div
          className="col-6"
          style={{ justifyContent: "flex-end", display: "flex" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
            }}
          >
            {/* <h4 className="mt-3">Selected Fields</h4> */}
            <div>
              <label>Book Name:</label>
              <input type="text" value={queData.bookName} disabled />
            </div>
            <div>
              <label>Chapter Name:</label>
              <input type="text" value={queData.chapterName} disabled />
            </div>
            <div>
              <label>Topic Name:</label>
              <input type="text" value={queData.topicName} disabled />
            </div>
            <div>
              <label>Sub-Topic Name:</label>
              <input type="text" value={queData.subTopicName} disabled />
            </div>
            <div>
              <label>Sub-Sub-Topic Name:</label>
              <input type="text" value={queData.subSubTopicName} disabled />
            </div>

            {/* {ocrConvertedQuestion?.length > 0 && (
              <div
                style={{
                  marginTop: "20px",
                  padding: "5px",
                  border: "1px solid black",
                }}
              >
                <h5>Converted OCR Question</h5>
                {renderHTML(ocrConvertedQuestion)}
              </div>
            )} */}
          </div>
        </div>

        <div className="col-6">
          <div className="mb-2">
            {/* dangerouslySetInnerHTML={{ __html: questionData?.value }} */}
            {renderHTML(
              wrapLatexWithCustomTag(questionData?.convertedValue) || "",
              HTML_PARSER_OPTIONS
            )}
          </div>
          <div className="mb-2">
            {questionData?.options?.map((option, index) => {
              return (
                <Option
                  item={option}
                  index={index}
                  showConvertOption={false}
                  correctPrompt={questionData?.correctPrompt}
                />
              );
            })}
          </div>
          <div className="mb-2">
            {renderHTML(
              wrapLatexWithCustomTag(questionData?.convertedSolution) || "",
              HTML_PARSER_OPTIONS
            )}
          </div>
        </div>
      </div>
      <div className="col-12">
        {ocrTextLoading ? (
          "Loading..."
        ) : (
          <>
            {ocrConvertedQuestion?.length > 0 && (
              <div
                style={{
                  marginTop: "20px",
                  padding: "5px",
                  border: "1px solid black",
                  overflow: "scroll",
                }}
              >
                <h5>Converted OCR Question</h5>
                {renderHTML(ocrConvertedQuestion)}
              </div>
            )}

            {ocrConvertedQuestion?.length > 0 &&
              allSimilarQuestions?.length > 0 && (
                <div
                  style={{
                    height: "fit-content",
                    width: "fit-content",
                    marginTop: "20px",
                    padding: "5px",
                    border: "1px solid black",
                    overflow: "scroll",
                  }}
                >
                  <h5>Similar Questions</h5>

                  <Form.Group as={Col} md="12" className="position-relative">
                    <Form.Control
                      style={{ height: "300px", overflow: "scroll" }}
                      as="select"
                      name="sectionTimeSharedFlag"
                      className="custom-select"
                      id="validationCustom04"
                      multiple
                      onChange={handleInputChange}
                      size="5"
                    >
                      {allSimilarQuestions?.map((each, index) => (
                        <option key={index} value={index}>
                          {each?.question}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                  <Button onClick={addAllSimilarQuestions}>
                    Add Similar Questions
                  </Button>
                </div>
              )}
          </>
        )}

        {/* <Button onClick={convertImgText}>Convert to Text</Button> */}
      </div>



      <Modal
        show={editQuestionModalVisible}
        onHide={() => setEditQuestionModalVisible(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ zIndex: 10000 }}
      >
        <form onSubmit={handleEditQuestion}>
          <Modal.Header closeButton>
            <h5 className="modal-title">Edit Question</h5>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="form-row">
                <div className="col-12">
                  <label>Question</label>
                  <CKEditor
                    editor={Editor}
                    data={questionData?.value}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      const obj = { ...questionData };
                      obj["value"] = data;
                      setQuestionData(obj);
                    }}
                    config={{
                      extraPlugins: [CKEditorImageUpload],
                    }}
                  />
                </div>
              </div>

              {questionOptions?.map((option, index) => {
                return (
                  <div
                    className="form-row mt-3"
                    style={{ alignItems: "center" }}
                  >
                    <div className="col-12">
                      <div className="mr-2">
                        <input
                          type="radio"
                          name="dynamic-radio"
                          required
                          value={option.prompt}
                          onChange={(e) => {
                            handleOptionInput(
                              option.value,
                              option.prompt,
                              index,
                              true
                            );
                          }}
                          checked={
                            option.correct ||
                            option.prompt === queData?.correctPrompt
                          }
                        />
                      </div>
                      <div>
                        <CKEditor
                          editor={Editor}
                          data={option.value}
                          onChange={(event, editor) => {
                            const obj = { ...questionData };
                            const data = editor.getData();
                            const i = index + 1;
                            const correct = option.correct;
                            let arr = [...questionOptions];
                            if (option.correct) {
                              arr = arr.map((item) => ({
                                ...item,
                                correct: false,
                              }));
                              obj.correctPrompt = i;
                            }
                            arr[index] = {
                              id: option.id,
                              value: data,
                              prompt: i,
                              correct,
                            };
                            setquestionOptions(arr);
                            obj.options = arr;
                            setQuestionData(obj);
                          }}
                          config={{
                            extraPlugins: [CKEditorImageUpload],
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
              <div className="form-row mb-1 mt-3">
                <button
                  type="button"
                  className="btn btn-primary mr-2"
                  onClick={() => {
                    addquestionOptions();
                  }}
                >
                  Add Option Field
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => {
                    removeLastQuestionOption();
                  }}
                >
                  Remove Option Field
                </button>
              </div>
              <div className="form-row">
                <div className="col-12">
                  <label>Solution</label>
                  <CKEditor
                    editor={Editor}
                    data={questionData?.solution}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      const obj = { ...questionData };
                      obj["solution"] = data;
                      setQuestionData(obj);
                    }}
                    config={{
                      extraPlugins: [CKEditorImageUpload],
                    }}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              onClick={() => openLatexConverter()}
              className="btn btn-info mr-auto"
            >
              LaTeX to Image
            </button>
            <button
              type="button"
              onClick={() => setEditQuestionModalVisible(false)}
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button className="btn btn-primary" disabled={editingQuestion}>
              {editLoader ? (
                <ClipLoader color="white" loading={editingQuestion} size={20} />
              ) : (
                "Edit Question"
              )}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      <Modal
        show={openQuestionModal}
        onHide={() => setOpenQuestionModal(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ zIndex: 10000 }}
      >
        <form onSubmit={handleConvertQuestion}>
          <Modal.Header closeButton>
            <h5 className="modal-title">Convert Question</h5>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="form-row">
                <div className="col-12">
                  <label>Original Question</label>
                  {renderHTML(wrapLatexWithCustomTag(questionData?.value) || "", HTML_PARSER_OPTIONS)}
                  {/* <CKEditor
                    editor={Editor}
                    data={questionData?.value}
                    disabled={true}
                    onChange={(event, editor) => { }}
                    config={{
                      extraPlugins: [CKEditorImageUpload],
                    }}
                  /> */}
                </div>
                <button
                  type="button"
                  class="btn btn-success ml-2 mr-1 mt-2"
                  onClick={() => {
                    checkConvertedQuestionHandler();
                  }}
                >
                  {convertingLoader ? (
                    <ClipLoader
                      color="white"
                      loading={convertingLoader}
                      size={20}
                    />
                  ) : (
                    "Convert Question"
                  )}
                </button>
              </div>
              <div className="form-row">
                <div className="col-12">
                  <label>Converted Question</label>
                  <CKEditor
                    editor={Editor}
                    data={convertedQuestion}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setConvertedQuestion(data);
                    }}
                    config={{
                      extraPlugins: [CKEditorImageUpload],
                    }}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              onClick={() => setOpenQuestionModal(false)}
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              className="btn btn-primary"
              disabled={updatingConvertedLoader}
            >
              {updatingConvertedLoader ? (
                <ClipLoader
                  color="white"
                  loading={updatingConvertedLoader}
                  size={20}
                />
              ) : (
                "Save Converted Question"
              )}
            </button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        fullscreen
        dialogClassName="fullModalWidth"
        show={openSolutionModal}
        onHide={() => setOpenSolutionModal(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ zIndex: 10000 }}
      >
        <form onSubmit={handleConvertSolution}>
          <Modal.Header closeButton>
            <h5 className="modal-title">Convert Solution</h5>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="form-row">
                <div className="col-6">
                  <label>Original Solution</label>
                  <CKEditor
                    editor={Editor}
                    data={questionData?.solution}
                    disabled={true}
                    onChange={(event, editor) => { }}
                    config={{
                      extraPlugins: [CKEditorImageUpload],
                    }}
                  />
                </div>
                <div className="col-6">
                  <label>Converted Solution</label>
                  <CKEditor
                    editor={Editor}
                    data={convertedSolution}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setConvertedSolution(data);
                    }}
                    config={{
                      extraPlugins: [CKEditorImageUpload],
                    }}
                  />
                </div>
              </div>
              <div className="form-row">
                <button
                  type="button"
                  class="btn btn-success ml-2 mr-1 mt-2"
                  onClick={() => {
                    checkConvertedSolutionHandler();
                  }}
                >
                  {convertingLoader ? (
                    <ClipLoader
                      color="white"
                      loading={convertingLoader}
                      size={20}
                    />
                  ) : (
                    "Convert Solution"
                  )}
                </button>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              onClick={() => setOpenSolutionModal(false)}
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              className="btn btn-primary"
              disabled={updatingConvertedLoader}
            >
              {updatingConvertedLoader ? (
                <ClipLoader
                  color="white"
                  loading={updatingConvertedLoader}
                  size={20}
                />
              ) : (
                "Save Converted Question"
              )}
            </button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* LaTeX to Image Converter Modal */}
      <Modal
        show={latexConverterModalVisible}
        onHide={() => setLatexConverterModalVisible(false)}
        aria-labelledby="latex-converter-modal"
        style={{ zIndex: 10001 }}
        size="lg"
      >
        <Modal.Header closeButton>
          <h5 className="modal-title">LaTeX to Image Converter</h5>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="form-row mb-3">
              <div className="col-12">
                <label>
                  <strong>Enter LaTeX Code:</strong>
                </label>
                <small className="form-text text-muted mb-2">
                  Examples: \frac{"{"}a{"}"}{"{"}b{"}"}  |  \int_0^1 x^2 dx  |  \sqrt{"{"}x^2 + y^2{"}"}  |  \sum_{"{"}i=1{"}"}{"^"}n i
                </small>
                <textarea
                  className="form-control"
                  rows="4"
                  value={latexInput}
                  onChange={(e) => setLatexInput(e.target.value)}
                  placeholder="e.g., \frac{a}{b} or \int_0^1 x^2 dx or paste multiple \[...\] blocks"
                  style={{ fontFamily: "monospace" }}
                />
              </div>
            </div>

            {latexInput.trim() && (
              <div className="form-row">
                <div className="col-12">
                  <label>
                    <strong>Preview (this will be downloaded as image):</strong>
                  </label>
                  <div
                    ref={latexPreviewRef}
                    style={{
                      padding: "20px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      backgroundColor: "white",
                      minHeight: "60px",
                    }}
                  >
                    {(() => {
                      // Split LaTeX by display math blocks \[...\] and filter out empty blocks
                      const blocks = latexInput
                        .split(/(\\\[.*?\\\])/gs)
                        .map(block => block.trim())
                        .filter(block => block.length > 0);
                      
                      return blocks.map((block, index) => (
                        <div
                          key={`${latexPreviewKey}-${index}`}
                          style={{
                            marginBottom: "10px",
                            display: "block",
                          }}
                        >
                          <math-field read-only>
                            {block}
                          </math-field>
                        </div>
                      ));
                    })()}
                  </div>
                </div>
              </div>
            )}
            
            {/* Upload Progress */}
            {uploadingToS3 && (
              <div className="form-row mt-3">
                <div className="col-12">
                  <label>
                    <strong>Uploading to S3...</strong>
                  </label>
                  <div className="progress">
                    <div
                      className="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      style={{ width: `${uploadProgress}%` }}
                      aria-valuenow={uploadProgress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {uploadProgress}%
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Generated IMG Tag */}
            {generatedImgTag && (
              <div className="form-row mt-3">
                <div className="col-12">
                  <label>
                    <strong>Generated IMG Tag (with responsive srcset):</strong>
                  </label>
                  <textarea
                    className="form-control"
                    rows="8"
                    value={generatedImgTag}
                    readOnly
                    style={{ fontFamily: "monospace", fontSize: "12px" }}
                  />
                  <button
                    type="button"
                    onClick={copyImgTagToClipboard}
                    className="btn btn-info mt-2"
                  >
                    <i className="bx bx-copy"></i> Copy to Clipboard
                  </button>
                  <small className="form-text text-muted mt-2">
                    This tag includes responsive images for all devices: small phones (400px), normal phones & tablets (800px), small desktops (1200px), and large screens (1600px).
                  </small>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            onClick={() => setLatexConverterModalVisible(false)}
            className="btn btn-secondary"
          >
            Close
          </button>
          <button
            type="button"
            onClick={downloadLatexImage}
            className="btn btn-success"
            disabled={convertingLatexToImage || uploadingToS3 || !latexInput.trim()}
          >
            {convertingLatexToImage ? (
              <ClipLoader color="white" loading={convertingLatexToImage} size={20} />
            ) : (
              "Download Image"
            )}
          </button>
          <button
            type="button"
            onClick={uploadLatexImageToS3}
            className="btn btn-primary"
            disabled={convertingLatexToImage || uploadingToS3 || !latexInput.trim()}
          >
            {uploadingToS3 ? (
              <ClipLoader color="white" loading={uploadingToS3} size={20} />
            ) : (
              <>
                <i className="bx bx-cloud-upload"></i> Upload to S3 & Get IMG Tag
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>

      <Snackbar
        open={isSnackBarShow}
        onClose={(e) => closeSnack(e)}
        TransitionComponent="TransitionUp"
        message={SnackBarMessage}
      />
    </div>
  );
}

export default QuestionLanguageVarient;
